import React from "react";
import { ContentType } from "@/types/content";
import { AudioLines, TvMinimalPlay, Mic, MessagesSquare } from "lucide-react";
interface ContentThumbnailProps {
  type: ContentType;
  thumbnailUrl?: string | null;
  title: string;
  className?: string;
}
const iconMap: Partial<Record<ContentType, React.ElementType>> = {
  audio: AudioLines,
  video: TvMinimalPlay,
  recording: Mic,
  chat: MessagesSquare
};
export const ContentThumbnail: React.FC<ContentThumbnailProps> = ({
  type,
  thumbnailUrl,
  title,
  className = ""
}) => {
  const IconComponent = iconMap[type];

  // For audio, video, recording, chat - always show icon (no stored thumbnails)
  if (IconComponent) {
    return <div className={`aspect-video w-full flex items-center justify-center bg-muted ${className}`}>
        <IconComponent className="w-14 h-14 text-muted-foreground" />
      </div>;
  }

  // For other types (pdf, youtube, web, doc, text) - use thumbnailUrl or placeholder
  return <img src={thumbnailUrl || "/placeholder.svg"} alt={title} className={`aspect-video w-full object-cover ${className}`} />;
};